/**
 * Entries that appear in the SuperAdmin nav popover (anchored to the yellow [SA]
 * badge inside `SuperAdminPanel.tsx`). Each entry routes to a `customPage` in
 * `pageRegistry.ts` and dismisses the SA panel on click.
 *
 * Add new SA-only debug pages here, not to the main SideNav — the goal is to
 * keep tools that operate on the data-driven nav (page management, etc.) out of
 * the data-driven nav itself.
 */

export interface SuperAdminNavEntry {
  /** Page name as registered in `pageRegistry.ts`. */
  pageName: string;
  /** Display label in the popover. */
  label: string;
  /** Section heading the entry appears under. */
  group: "Admin tools" | "Galleries";
  /** Renders the entry one indent step in from the section root. Used to
   *  visually subordinate sub-tools to their parent (e.g. "Documentation" /
   *  "Audit Log" under "Page Management"). Order within the group is the
   *  array order, so the parent must precede its children. */
  indent?: boolean;
  /** Listed only on the top global endpoint; the page itself refuses everywhere else. */
  globalOnly?: boolean;
}

export const superAdminNavEntries: readonly SuperAdminNavEntry[] = [
  { pageName: "pageMgmt", label: "Page Management", group: "Admin tools" },
  { pageName: "pageMgmtDocs", label: "Documentation", group: "Admin tools", indent: true },
  { pageName: "pageMgmtAudit", label: "Audit Log", group: "Admin tools", indent: true },
  { pageName: "offloadzones", label: "Offload Zones", group: "Admin tools", globalOnly: true },
  { pageName: "billingAccounts", label: "Billing Accounts", group: "Admin tools" },
  { pageName: "billingCoverage", label: "Coverage", group: "Admin tools", indent: true },
  { pageName: "billingInvoice", label: "Platform Invoices", group: "Admin tools", indent: true },
  { pageName: "icongallery", label: "Icon Gallery", group: "Galleries" },
  { pageName: "fontgallery", label: "Font Gallery", group: "Galleries" },
  { pageName: "filtergallery", label: "Filter Gallery", group: "Galleries" },
  { pageName: "modalgallery", label: "Modal Gallery", group: "Galleries" },
  { pageName: "dategallery", label: "Date Gallery", group: "Galleries" },
];
